module.exports = require("./lib/_stream_writable.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/readable-stream/writable.js
 ** module id = 365
 ** module chunks = 0
 **/